import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center'
    },
    label: {
        color: 'hsla(0,0%,100%,.5)',
        fontSize: 16,
        width: 100,
        fontFamily: 'PT-sans, sans-serif',
    },
    percent: {
        color: '#fff',
        fontSize: 16,
        fontFamily: 'PT-sans, sans-serif',
    }
}))

export {
    useStyles
}